var map = {
	"./0.png": "db2c",
	"./1.png": "5158",
	"./2.png": "d072",
	"./3.png": "7858",
	"./4.png": "4b7c",
	"./4old.png": "71a0",
	"./5.png": "a365",
	"./6.png": "d739",
	"./bg.png": "84bd",
	"./left.png": "43f8",
	"./right.png": "be2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5cd";